module.exports = __webpack_public_path__ + "static/media/costpic3@3x.4618b286.png";